import React, { useEffect, useState, useContext } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import Modal from 'react-modal';

import "@fontsource/roboto";
import './CoopenaeAuto.css';

import Pages from './components/pages/Pages';
import http from '../../../services/http';
import useToken from '../../../hooks/useToken';
import { endPoints } from '../../../utils/constanst';
import { DataContext, DataProvider } from './data/DataContext';
import { IconProgressBar, LineProgressBar, ControlButton } from './components/controls';
import { InitPage, buildPricingData } from './data/Data';
import { plan } from './data/MochaData';
import { buildData, buildDataError } from './data/Services';




const CoopenaeAuto = () => {
    const { loading } = useToken();

    useEffect(() => {
        setTimeout(() => {
            const preloader = document.querySelector('.site-preloader');
            if (preloader) {
                preloader.addEventListener('transitionend', (event) => {
                    if (event.propertyName === 'opacity')
                        preloader.parentNode.removeChild(preloader);
                });
                preloader.classList.add('site-preloader__fade');
            }
        }, 600);
    }, []);

    return (
        <DataProvider loading={loading}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Switch>
                    <Route exact path="/micrositio/coopenae_auto/" component={Layout} />
                    <Redirect to="/micrositio/coopenae_auto/" />
                </Switch>
            </BrowserRouter>
        </DataProvider>
    );
}

const Layout = ({ location }) => {
    const totalPages = 4;
    const [index, setIndex] = useState(InitPage);
    const [loading, setLoading] = useState(false);
    const [isOpenMessage, setOpenMessage] = useState(false);
    const { CoopenaeAuto, setCoopenaeAuto, changeHandler } = useContext(DataContext);


    const decrement = () => {
        if (index !== 0)
            setIndex(index - 1)
    }
    const increment = () => {
        if (index <= totalPages) setIndex(index + 1);
    };
    const handleSubmit = async () => {
        let result = document.querySelector("form").reportValidity();
        if (index === 1 && result) {
            if (CoopenaeAuto.isDatasheet)
                await executePricing();
        }
        else if (index == 2 && result)
            createRequestPolicy();
        else if (result)
            increment();
    }


    /*useEffect*/

    useEffect(() => {
        setCoopenaeAuto({ ...CoopenaeAuto, planId: CoopenaeAuto.currency === 'U$' ? plan.dolar : plan.colon });
    }, [CoopenaeAuto.currency]);

    useEffect(() => {
        if (CoopenaeAuto.planId !== 0) {
            setLoading(true);
            Promise.all([
                http(endPoints.fees(CoopenaeAuto.planId)).getWithParam(`plan=${CoopenaeAuto.planId}`),
                http(endPoints.brands(CoopenaeAuto.planId)).get(),
                http(endPoints.deductibles(CoopenaeAuto.planId)).get(),
                http(`${endPoints.catalog}rastreosatelital`).get(),
                http(endPoints.coverages(CoopenaeAuto.planId)).get(),
                http(endPoints.configPlan(1, CoopenaeAuto.planId)).get(),
                http(endPoints.vhUses).get()
            ]).then(r => {
                CoopenaeAuto.setCatalogs({
                    paymentFrequency: r[0],
                    brand: r[1],
                    deductible: r[2],
                    device: r[3],
                    coverages: r[4],
                    planConfig: r[5],
                    vehicleUse: r[6]
                });
            })
                .catch(() => setLoading(false))
                .finally(() => setLoading(false));
        }
    }, [CoopenaeAuto.planId]);

    useEffect(() => {
        if ((CoopenaeAuto.planId !== 0 && CoopenaeAuto.planId !== '') && (CoopenaeAuto.brand !== 0 && CoopenaeAuto.brand !== '')) {
            setLoading(true);
            http(endPoints.models(CoopenaeAuto.planId, CoopenaeAuto.brand)).get()
                .then((r) => CoopenaeAuto.setCatalogs({ model: r }))
                .finally(() => setLoading(false));
        }
    }, [CoopenaeAuto.brand])

    useEffect(() => {
        if ((CoopenaeAuto.planId !== 0 && CoopenaeAuto.planId !== '') && (CoopenaeAuto.brand !== 0 && CoopenaeAuto.brand !== '') && (CoopenaeAuto.model !== 0 && CoopenaeAuto.model !== '')) {
            setLoading(true);
            http(endPoints.lastYear(CoopenaeAuto.planId, CoopenaeAuto.brand, CoopenaeAuto.model)).get()
                .then((r) => CoopenaeAuto.setCatalogs({ year: r }))
                .finally(() => setLoading(false));
        }
    }, [CoopenaeAuto.model])

    useEffect(() => {
        setCoopenaeAuto({ ...CoopenaeAuto, isDatasheet: false })
        if ((CoopenaeAuto.planId !== 0 && CoopenaeAuto.planId !== '') && (CoopenaeAuto.brand !== 0 && CoopenaeAuto.brand !== '') && (CoopenaeAuto.model !== 0 && CoopenaeAuto.model !== '') && (CoopenaeAuto.year !== 0 && CoopenaeAuto.year !== '')) {
            setLoading(true);
            http(endPoints.datasheet(CoopenaeAuto.planId, CoopenaeAuto.brand, CoopenaeAuto.model, CoopenaeAuto.year)).get()
                .then((r) => CoopenaeAuto.setPricing(r))
                .then(() => setCoopenaeAuto({ ...CoopenaeAuto, isDatasheet: true }))
                .finally(() => setLoading(false));
        }
    }, [CoopenaeAuto.planId, CoopenaeAuto.brand, CoopenaeAuto.model, CoopenaeAuto.year])


    useEffect(() => {

    }, [CoopenaeAuto]);

    /**/

    const executePricing = async () => {
        setLoading(true);
        let data = buildPricingData(CoopenaeAuto);
        CoopenaeAuto.setPricing(data);
        await http(endPoints.tarificar(CoopenaeAuto.planId)).post(data)
            .then(r => { CoopenaeAuto.setCatalogs({ rates: r }); })
            .then(() => increment())
            .catch((e) => {
                setCoopenaeAuto({ ...CoopenaeAuto, message: e });
                setOpenMessage(true);
                setLoading(false);
            })
            .finally(() => setLoading(false));
    }

    const createRequestPolicy = () => {
        setLoading(true);
        let searchParams = new URLSearchParams(location.search);
        let src = searchParams.get('source');
        const data = buildData(CoopenaeAuto, src);
        http(endPoints.createCoopenaeAuto).post(data)
            .then((r) => {
                setCoopenaeAuto({ ...CoopenaeAuto, isSaved: true, requestNumber: r.id });
            }).
            then(() => (setLoading(false)))
            .catch((error) => {
                setLoading(false);
                setCoopenaeAuto({ ...CoopenaeAuto, isSaved: false });
                sendMailError();
                increment();
            })
            .finally(() => {
                increment();
            });
    }

    const sendMailError = () => {
        const data = buildDataError(CoopenaeAuto);
        http(endPoints.notificationCoopenaeError).post(data);
    }



    return (
        <div className="container-coopenae">
            <div className="layout-coopenae">
                <div className="mt-50">
                    <span className="title-ca ">
                        ¡Calculá tu Auto LAFISE Plus ahora!
                    </span>
                </div>
                <div className="mb-20 mt-10">
                    <span className="title2-ca">
                        Registrado ante la SUGESE bajo el nombre de SEGURO DE AUTOMÓVILES LAFISE PLUS y número de Registro G01-01-A14-715 de Seguros
                    </span>
                </div>
                <IconProgressBar indexProgress={index} />
                <LineProgressBar indexProgress={index} />
                <form action="">
                    <Pages indexProgress={index} />
                    <ControlButton indexProgress={index} totalPages={totalPages} decrement={decrement} handleSubmit={handleSubmit} />
                </form>
            </div>
            <Modal className="modal" isOpen={loading} show={loading} ariaHideApp={false}>
                <div className="dialog-center-content-ca">
                    <p className="text-center">Cargando...</p>
                </div>
            </Modal>
            <Modal className="modal" isOpen={isOpenMessage} show={isOpenMessage} ariaHideApp={false}>
                <div className="modal-title-ca">
                    <span className="txt-title-modal">Información</span>
                </div>
                <div className="modal-body-info-ca">
                    {CoopenaeAuto.message}
                </div>
                <div className="modal-footer-ca">
                    <button className="modal-btn-close-ca" onClick={() => setOpenMessage(false)}>Cerrar</button>
                </div>
            </Modal>
        </div>
    );
}

export default CoopenaeAuto;